module.exports = __webpack_public_path__ + "static/media/PCN-2024-8-20-01-LG75.6c6ecf0f.pdf";